import { useFormContext, useWatch } from 'react-hook-form';
import { QueryKeyConfig } from '../../api/api-helper';
import { useLoadData } from '../../hooks/useLoadData';
import { FormSelect } from './form-select.component';
import { ApiResponse } from '../../models/api-response';
import { LoadingIndicator } from '../loading-indicator.component';

interface SelectFieldDynamicProps {
  getQueryKeyConfig: (inputData: any, getValues: any) => QueryKeyConfig;
  watchKeys?: string[];
  label: string;
  name: string;
  required?: boolean;
  optionsValueKey?: string;
  optionsLabelKeys?: string[];
  optionsTypeKeys?: string;
  defaultItemKey?: string;
  onChange?: any;
  disabled?: boolean;
}

export const FormSelectDynamic = ({
  name,
  label,
  watchKeys,
  optionsValueKey,
  optionsLabelKeys,
  optionsTypeKeys,
  defaultItemKey,
  onChange,
  getQueryKeyConfig,
  disabled,
}: SelectFieldDynamicProps): any => {
  const { getValues } = useFormContext();

  useWatch({
    name: watchKeys || [],
  });

  const { data, isLoading, isFetching, isError } = useLoadData<ApiResponse<any[]>>(
    getQueryKeyConfig(
      watchKeys?.reduce((acc: any, key) => ({ ...acc, [key]: getValues(key) }), {}),
      getValues
    )
  );

  const getListOptions = (adata?: any[]) => {
    return adata
      ? adata.map((d) => ({
        value: d[optionsValueKey ?? name],
        label: optionsLabelKeys
          ? optionsLabelKeys.map((key) => d[key]).join(' - ')
          : 'No label',
        isDefault: defaultItemKey ? d[defaultItemKey] : false,
        type: optionsTypeKeys ? d[optionsTypeKeys] : undefined, // 👈 added line
      }))
      : [];
  };

  return (
    <div style={{ flex: '1' }}>
      <LoadingIndicator isLoading={isLoading || isFetching} />
      <FormSelect
        options={getListOptions(data?.data ?? [])}
        label={label}
        name={name}
        onChange={onChange}
        disabled={disabled}
      />
    </div>
  );
};

FormSelectDynamic.defaultProps = {
  watchKeys: undefined,
  optionsValueKey: 'id',
  defaultItemKey: 'name',
  onChange: () => {
    return;
  },
};
